import { InfoWithLabel } from "@volca/ui/components/ui/info-with-label";
import { Stack } from "@volca/ui/components/ui/stack";
import {
  DocumentTimestamps,
  MatchedJobField,
  PurchaseOrderField,
} from "@/accounts-payable/common";
import { useApBusinessTimeZone } from "@/accounts-payable/common/use-ap-business-time-zone";
import type { ApReceipt } from "@/accounts-payable/types";
import {
  formatApDate,
  formatApDateTime,
  receiptPaymentLabel,
} from "@/accounts-payable/utils";
import { formatCentsOrDashIfZero } from "@/core/utils/money";

export const ReceiptFieldsSection = ({
  receipt,
  businessId,
}: {
  receipt: ApReceipt;
  businessId: string | null;
}) => {
  const timeZone = useApBusinessTimeZone();
  return (
    <Stack gap={6}>
      <Stack gap={4}>
        <MatchedJobField document={receipt} businessId={businessId} />
        <PurchaseOrderField document={receipt} businessId={businessId} />
      </Stack>
      <Stack gap={0} className="grid w-full grid-cols-2 gap-4">
        <InfoWithLabel label="Purchased">
          {receipt.purchased_at
            ? formatApDateTime(receipt.purchased_at, timeZone)
            : formatApDate(receipt.receipt_date)}
        </InfoWithLabel>
        <InfoWithLabel label="Paid with">
          {receiptPaymentLabel(receipt) ?? "—"}
        </InfoWithLabel>
        <InfoWithLabel label="PO / job name at the register">
          {receipt.po_number ?? "—"}
        </InfoWithLabel>
        <InfoWithLabel label="Tax">
          {receipt.tax_amount_cents != null
            ? formatCentsOrDashIfZero(receipt.tax_amount_cents)
            : "—"}
        </InfoWithLabel>
        <InfoWithLabel label="Store" className="col-span-2">
          {[
            receipt.store_number && `#${receipt.store_number}`,
            receipt.store_address,
          ]
            .filter(Boolean)
            .join(" · ") || "—"}
        </InfoWithLabel>
      </Stack>
      <DocumentTimestamps document={receipt} />
    </Stack>
  );
};
